export type { IProps } from './Application'
export { default } from './Application'
